import { render } from "./StandardHeader.vue?vue&type=template&id=2339b907"
import script from "./StandardHeader.vue?vue&type=script&lang=js"
export * from "./StandardHeader.vue?vue&type=script&lang=js"

import "./StandardHeader.vue?vue&type=style&index=0&id=2339b907&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__